import { render, staticRenderFns } from "./qualityLegislation.vue?vue&type=template&id=8455747e&scoped=true"
import script from "./qualityLegislation.vue?vue&type=script&lang=js"
export * from "./qualityLegislation.vue?vue&type=script&lang=js"
import style0 from "./qualityLegislation.vue?vue&type=style&index=0&id=8455747e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8455747e",
  null
  
)

export default component.exports